// Copyright 2019 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     https://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/** @module common-sk/modules/jsonOrThrow */ // ** The type of Error thrown by jsonOrThrow. */
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    JsonOrThrowError: function() {
        return JsonOrThrowError;
    },
    jsonOrThrow: function() {
        return jsonOrThrow;
    }
});
let JsonOrThrowError = class JsonOrThrowError extends Error {
    constructor(resp){
        super();
        this.message = `Bad network response: ${resp.statusText}`;
        this.resp = resp;
        this.status = resp.status;
    }
};
function jsonOrThrow(resp) {
    if (resp.ok) {
        return resp.json();
    }
    throw new JsonOrThrowError(resp);
}
